export default __webpack_public_path__ + "static/logo-starship-f2607b75693dfb61cb005708aeb45375.png";